import { html } from "lit";
import { renderStandardPictureElement } from "../../../utils";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "MyTrumpf/Partial Templates/Service Agreement Element",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const colorValue = (status) =>
    status === "active"
        ? "success"
        : status === "expired"
        ? "error"
        : status === "starting soon"
        ? "warning"
        : "disabled";

const statusColorValue = (status) =>
    status === "active"
        ? "green"
        : status === "starting soon"
        ? "orange"
        : status === "expired"
        ? "red"
        : "grey";

const serviceAgreementTemplate = (args) => {
    return html`
        <div
            class="ux-u-shadow ux-u-px-xxs ux-u-px-md-xs ux-u-pt-xs ux-u-pb-xxs"
        >
            <div class="ux-row">
                <div class="ux-col-12 ux-col-md-4 ux-col-xl-2">
                    ${renderStandardPictureElement({
                        width: 159,
                        height: 100,
                    })}
                </div>

                <div class="ux-col-12 ux-col-md-8">
                    <div
                        class="ux-u-d-flex ux-u-flex-ai-center ux-u-flex-wrap-wrap ux-u-mt-xxs ux-u-mt-md-zero ux-u-mb-xxxs"
                    >
                        <div class=" ux-u-mb-xxxs">
                            <span class="ux-color-${colorValue(args.status)}">
                                <ux-icon
                                    name="circle-checkmark"
                                    filled
                                    class="ux-u-mr-xxxs"
                                    size-l="23"
                                ></ux-icon>
                            </span>
                            <span
                                class="ux-text-headline ux-text-headline--small ux-u-mr-xs"
                                >${args.headline}</span
                            >
                        </div>
                        <div
                            class="ux-u-inline ux-text-status ux-u-mb-xxxs ux-text-status--${statusColorValue(
                                args.status
                            )} "
                        >
                            <ux-icon name="circle-filled"></ux-icon>

                            ${args.status}
                        </div>
                    </div>
                    <div class="ux-row">
                        <div
                            class="ux-col-12 ux-col-md-4 ux-u-mb-xxs ux-u-mb-md-zero"
                        >
                            <div
                                class="ux-info-box__headline ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-mb-md-xxxs u-white-space-nowrap"
                            >
                                Contract No.
                            </div>
                            <div>${args.contractNr}</div>
                        </div>
                        <div
                            class="ux-col-12 ux-col-md-4 ux-u-mb-xxs ux-u-mb-md-zero"
                        >
                            <div
                                class="ux-info-box__headline ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-mb-md-xxxs"
                            >
                                Start
                            </div>
                            <div>${args.startDate}</div>
                        </div>
                        <div
                            class="ux-col-12 ux-col-md-4 ux-u-mb-xxs ux-u-mb-md-zero"
                        >
                            <div
                                class="ux-info-box__headline ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-mb-md-xxxs"
                            >
                                End
                            </div>
                            <div>${args.endDate}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ux-row">
                ${args.expireDisclaimer
                    ? html`<p
                          class="ux-col-12 ux-text-normal ux-color-error ux-u-mt-md-xxs ux-u-mb-xxs ux-u-mb-md-zero"
                      >
                          ${args.expireDisclaimer}
                      </p>`
                    : ""}
                <div class="ux-col-12 ux-u-mt-md-xxs">
                    <span
                        class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                        >INCLUDED OPTIONS</span
                    >
                    <p class="ux-u-mt-xxxs ux-u-mb-zero">${args.options}</p>
                </div>
            </div>
            <div class="ux-row ux-u-d-flex ux-u-flex-ai-end">
                <div class="ux-col-12 ux-col-md ux-u-mt-xxxs">
                    <ux-collapsible
                        button-text-collapsed="Show details"
                        button-text-expanded="Hide details"
                        direction="bottom"
                    >
                        <ul class="ux-list ux-u-mt-zero ux-u-mb-xxs">
                            <li>
                                Lorem ipsum dolor sit amet, consetetur
                                sadipscing elitr, sed diam nonumy eirmod tempor
                                invidunt ut labore et dolore magna aliquyam
                                erat, sed diam voluptua.
                            </li>
                            <li>
                                At vero eos et accusam et justo duo dolores et
                                ea rebum. Stet clita.
                            </li>
                            <li>
                                At vero eos et accusam et justo duo dolores et
                                ea rebum. Stet clita.
                            </li>
                            <li>
                                At vero eos et accusam et justo duo dolores et
                                ea rebum. Stet clita.
                            </li>
                            <li>
                                At vero eos et accusam et justo duo dolores et
                                ea rebum. Stet clita.
                            </li>
                            <li>
                                At vero eos et accusam et justo duo dolores et
                                ea rebum. Stet clita.
                            </li>
                            <li>
                                At vero eos et accusam et justo duo dolores et
                                ea rebum. Stet clita.
                            </li>
                        </ul>
                        <div class="ux-col-10 ux-u-ml-xs">
                            <span
                                class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                            >
                                Name Option 1
                            </span>
                            <ul class="ux-list ux-u-mt-zero ux-u-mb-xxs">
                                <li>
                                    At vero eos et accusam et justo duo dolores
                                    et ea rebum. Stet clita.
                                </li>
                                <li>
                                    At vero eos et accusam et justo duo dolores
                                    et ea rebum. Stet clita.
                                </li>
                            </ul>
                        </div>
                        <!-- Repeat for options 2-7 -->
                    </ux-collapsible>
                </div>
                ${args.detailsLink
                    ? html`<div
                          class="ux-col ux-col-md-auto ux-u-mt-xxxs ux-u-mb-xxxs"
                      >
                          
                              href=${args.detailsLink}
                              class="ux-button ux-button--icon-only"
                              aria-label="Lorem Ipsum"
                              role="button"
                              ><ux-icon name="chevron-right"></ux-icon
                          ></a>
                      </div>`
                    : null}
            </div>
        </div>
    `;
};

export const Active = serviceAgreementTemplate.bind({});
Active.args = {
    headline: "Service Agreement Maintenance",
    status: "active",
    contractNr: "31674526 / 10",
    startDate: "01.09.2019",
    endDate: "01.09.2022",
    expireDisclaimer: "This service agreement is about to expire. Extend now.",
    options: [
        "Option Name 1 / ",
        "Option Name 2 / ",
        "Option Name 3 / ",
        "Option Name 4 / ",
        "Option Name 5 / ",
        "Option Name 6 / ",
        "Option Name 7",
    ],
    detailsLink: "#",
};

export const StartingSoon = serviceAgreementTemplate.bind({});
StartingSoon.args = {
    headline: "Service Agreement Maintenance",
    status: "starting soon",
    contractNr: "31674526 / 10",
    startDate: "01.09.2019",
    endDate: "01.09.2022",
    options: [
        "Option Name 1 / ",
        "Option Name 2 / ",
        "Option Name 3 / ",
        "Option Name 4 / ",
        "Option Name 5 / ",
        "Option Name 6 / ",
        "Option Name 7",
    ],
    detailsLink: "#",
};

export const Expired = serviceAgreementTemplate.bind({});
Expired.args = {
    headline: "Service Agreement Maintenance",
    status: "expired",
    contractNr: "31674526 / 10",
    startDate: "01.09.2019",
    endDate: "01.09.2022",
    options: [
        "Option Name 1 / ",
        "Option Name 2 / ",
        "Option Name 3 / ",
        "Option Name 4 / ",
        "Option Name 5 / ",
        "Option Name 6 / ",
        "Option Name 7",
    ],
    detailsLink: "#",
};

const noValidServiceAgreementTemplate = (args) => {
    return html`
        <div class="ux-u-p-xs ux-u-shadow">
            <div class="ux-u-d-flex ux-u-flex-ai-center">
                <span class="ux-color-error">
                    <ux-icon name="circle-cross" class="ux-u-mr-xxxs"></ux-icon>
                </span>
                <span
                    class="ux-text-headline ux-text-headline--small ux-u-mr-xs"
                    >${args.headline}</span
                >
            </div>
            <p class="ux-u-mb-xs">${args.copy}</p>
            <a class="ux-button ux-button--primary" href="#"
                >Request Serivce Agreement</a
            >
        </div>
    `;
};

export const NoServiceAgreement = noValidServiceAgreementTemplate.bind({});
NoServiceAgreement.args = {
    headline: "No valid Service Agreement",
    copy:
        "Copytext Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
};
